export const REQUEST_FETCH_PRODUCTS_WITH_SKUS = 'REQUEST_FETCH_PRODUCTS_WITH_SKUS';
export const FETCH_PRODUCTS_TYPE = 'PRODUCTS';
export const FETCH_PRODUCTS_PENDING = `${FETCH_PRODUCTS_TYPE}_PENDING`;
export const FETCH_PRODUCTS_FULFILLED = `${FETCH_PRODUCTS_TYPE}_FULFILLED`;
export const FETCH_PRODUCTS_REJECTED = `${FETCH_PRODUCTS_TYPE}_REJECTED`;
export const LOAD_MORE_PRODUCTS = 'LOAD_MORE_PRODUCTS';

export const fetchProductsActionCreator = (sliceId, promise, meta = {}) => ({
  meta: {
    ...meta,
    sliceId,
  },
  type: FETCH_PRODUCTS_TYPE,
  payload: promise,
});

export const requestFetchProductWithSkus = (sliceId, skus, overwriteItemSetItems) => ({
  type: REQUEST_FETCH_PRODUCTS_WITH_SKUS,
  payload: {
    sliceId,
    skus,
  },
  meta: {
    overwriteItemSetItems,
  },
});
